// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const TimelineOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_2918)"},"children":[{"tag":"path","attrs":{"d":"M23 8a2 2 0 01-2.51 1.93l-3.56 3.55A2 2 0 0115 16a2 2 0 01-1.93-2.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56A2 2 0 013 18a2 2 0 01-2-2 2 2 0 012.51-1.93l4.56-4.55A2 2 0 0110 7a2 2 0 011.93 2.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56A2 2 0 0121 6a2 2 0 012 2z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_2918"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"timeline","theme":"outlined"};

const TimelineOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={TimelineOutlinedSvg} />;
  TimelineOutlined.displayName = 'TimelineOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(TimelineOutlined);
